(function () {
  'use strict';
  /* global $, angular */

  /**
   * Keeps CSS custom properties in sync with the live site header / promo banner
   * so sticky microsite nav (and related offsets) track wrapping banner text and
   * breakpoint-specific header heights.
   *
   *   --site-banner-height
   *   --site-header-height
   *   --site-header-hide-offset  (how far to slide the main nav when collapsed)
   *
   * Header height is measured from the navbar's top edge to the lowest visible
   * chrome (including absolutely positioned .top-nav), so it stays correct even
   * when .navbar-fixed-top has a negative `top` during hide-main-nav.
   */
  angular.module('Milestone').run(['$window', '$timeout', function ($window, $timeout) {
    var root = $window.document.documentElement;
    var resizeTimer = null;
    var observer = null;

    function bannerEl() {
      return $window.document.querySelector('.navbar-fixed-top .covid19-update');
    }

    function headerEl() {
      return $window.document.querySelector('.navbar-fixed-top');
    }

    function px(value) {
      return Math.max(0, Math.round(value || 0)) + 'px';
    }

    function isVisible(el) {
      return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
    }

    function relativeBottom(el, navTop) {
      if (!isVisible(el)) {
        return 0;
      }
      return el.getBoundingClientRect().bottom - navTop;
    }

    function isPhone() {
      return $window.matchMedia && $window.matchMedia('(max-width: 767px)').matches;
    }

    function measureHeaderHeight(header) {
      var navTop = header.getBoundingClientRect().top;
      var height = 0;
      var i;
      var nodes;
      // Phone: only the promo banner + logo row. The full .navbar-fixed-top box
      // and #navbar-collapse (even when closed / height: 100%) inflate this and
      // push #microsite-secondary down, which looks like an extra-tall header.
      var selectors = isPhone() ? [
        '.covid19-update',
        '.navbar-header.mobile-navbar-header'
      ] : [
        '.top-nav',
        '.covid19-update',
        '.navbar-header',
        '#navbar-collapse',
        '.navbar-collapse'
      ];

      if (!isPhone()) {
        height = relativeBottom(header, navTop);
      }

      for (i = 0; i < selectors.length; i++) {
        nodes = header.querySelectorAll(selectors[i]);
        Array.prototype.forEach.call(nodes, function (node) {
          height = Math.max(height, relativeBottom(node, navTop));
        });
      }

      return Math.max(0, height);
    }

    function sync() {
      var banner = bannerEl();
      var header = headerEl();
      if (!header) {
        return;
      }

      var bannerHeight = isVisible(banner) ? banner.offsetHeight : 0;
      root.style.setProperty('--site-banner-height', px(bannerHeight));

      // Let banner-driven navbar-header margin apply, then measure full chrome.
      $window.requestAnimationFrame(function () {
        var headerHeight = measureHeaderHeight(header);
        var hideOffset = Math.max(0, headerHeight - bannerHeight);

        root.style.setProperty('--site-header-height', px(headerHeight));
        root.style.setProperty('--site-header-hide-offset', px(hideOffset));
      });
    }

    function scheduleSync() {
      if (resizeTimer) {
        $window.clearTimeout(resizeTimer);
      }
      resizeTimer = $window.setTimeout(sync, 50);
    }

    function observe() {
      if (typeof $window.ResizeObserver !== 'function') {
        return;
      }
      if (observer) {
        observer.disconnect();
      }
      observer = new $window.ResizeObserver(scheduleSync);
      var header = headerEl();
      var banner = bannerEl();
      if (header) {
        observer.observe(header);
      }
      if (banner) {
        observer.observe(banner);
      }
    }

    $($window).on('load resize orientationchange', scheduleSync);
    $timeout(function () {
      sync();
      observe();
    }, 0);
  }]);
})();
